import { lsApiService } from 'ls-vue-common';

const services = {
    recurring: 'Recurring Mowing',
    'one-time': 'One-time mowing',
    'clean-up': 'Cleanups',
    fertilization: 'Lawn Treatment',
    aeration: 'Aeration',
    other: 'Other',
};

function generateNoteAndSubmit(payload) {
    const { recurring, fertilization, aeration, other } = payload.manualRequest.services;
    const oneTime = payload.manualRequest.services['one-time'];
    const cleanup = payload.manualRequest.services['clean-up'];
    const { order_id, fname, lname, phone } = payload.order;

    const data = {
        order_id,
        fname,
        lname,
        email: payload.contactInfo.email,
        phone,
        mowing: oneTime || recurring,
        aeration,
        fertilization,
        overseeding: false, // overseeding has been repalced with 'other'
    };

    let notesOnMowing = 'Mowing selected:\n';
    if (oneTime || recurring) {
        if (recurring) {
            notesOnMowing += `* ${services.recurring}\n`;
        }
        if (oneTime) {
            notesOnMowing += `* ${services['one-time']}\n`;
        }
    } else {
        notesOnMowing += '(none)\n';
    }

    let notesOnOtherServices = 'Services selected:\n';
    if (aeration || cleanup || fertilization || other) {
        if (aeration) {
            notesOnOtherServices += `* ${services.aeration}\n`;
        }
        if (cleanup) {
            notesOnOtherServices += `* ${services['clean-up']}\n`;
        }
        if (fertilization) {
            notesOnOtherServices += `* ${services.fertilization}\n`;
        }
        if (other) {
            notesOnOtherServices += `* ${services.other}\n`;
        }
    } else {
        notesOnOtherServices += '(none)\n';
    }

    const enteredNotes = `Entered notes: ${payload.manualRequest.details}\n`;
    data.notes = `${notesOnMowing}\n\n${notesOnOtherServices}\n\n${enteredNotes}\n\nOrder ID: ${order_id}`;
    return lsApiService.request({
        method: 'POST',
        route: '/signup/contact',
        payload: data,
    });
}

const manualRequestService = {
    generateNoteAndSubmit,
};

export default manualRequestService;
